<template>
    <div class="index">
        <pc>
            <qHeader></qHeader>
            <el-container>
                <div class="box">
                    <div class="title">天津国土学院能源站四色图</div>
                    <img class="img" src="@/assets/images/cockpit/escapeMap.png">
                    <div class="prompt">
                        <div class="prompt-left">(蓝色:低风险黄色:一般风险橙色:较大风险红色:重大风险)</div>
                        <div class="prompt-right">
                            <div><img src="@/assets/images/cockpit/消火栓.png">消火栓</div>
                            <div><img src="@/assets/images/cockpit/灭火器.png">灭火器</div>
                            <div><img src="@/assets/images/cockpit/长箭头.png">逃生路线</div>
                        </div>
                    </div>
                </div>
            </el-container>
            <div class="foot"></div>
        </pc>
    </div>
</template>
<script>
// 引入组件
import pc from "@/components/cockpit/pc.vue";
import qHeader from "@/components/cockpit/header.vue";

export default {
    data() {
        return {
        }
    },
    // 注册组件
    components: {
        pc,
        qHeader,
    },
    methods: {
        // handleBack(){
        //     console.log("1111111111");

        // }
        // 自动全屏
        fullscreenCheck() {
            if (!document.fullscreenElement &&
                !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {  // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) {
                    document.documentElement.msRequestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            }
        }
    },
    mounted() {
        // this.handleServe()

        // 自动全屏
        this.fullscreenCheck()

        // 抬起esc退出
        this.$nextTick(() => {
            document.onkeyup = (e) => {
                // console.log(e);
                //此处填写你的业务逻辑即可
                if (e.key == "Escape") {
                    this.$router.back()
                }
            }
        })

    },
}
</script>
<style lang="less" scoped>
/*引入字体*/
@font-face {
    /*自定义文字名称*/
    font-family: "zanku";
    /*字体文件的路径*/
    src: url("@/assets/font/站酷文艺体.ttf");
}

.index::v-deep {
    background-color: #051C55;
    position: fixed;
    right: 0;
    top: 0;
    left: 0;
    bottom: 0;

    .left-header,
    .right-header,
    .sise {
        display: none;
    }

    .el-container {
        display: flex;
        justify-content: center;
        align-items: center;

        .box {
            width: 1850px;
            height: 900px;
            text-align: center;
            background-image: url(@/assets/images/cockpit/bj4.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;

            .title {
                font-size: 28px;
                font-weight: bold;
                color: #fff;
                padding: 20px 0;
                // 字体间距
                letter-spacing: 5px;
                font-family: zanku;
            }

            .prompt {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px 100px;

                .prompt-left {
                    font-size: 25px;
                    color: #FFF;
                    font-weight: 800;
                    letter-spacing: 3px;
                }

                .prompt-right {
                    display: flex;
                    font-size: 20px;
                    color: #58bbd5;
                    font-weight: 800;
                    letter-spacing: 3px;

                    >div {
                        margin: 0 20px;
                        height: 30px;
                        line-height: 30px;
                        display: flex;
                        align-items: center;

                        img {
                            height: 30px;
                            margin-right: 5px;
                        }
                    }
                }
            }

            .img {
                width: 1650px;
            }
        }

    }

    .foot {
        width: 100%;
        height: 25px;
        background-image: url(@/assets/images/cockpit/foot.png);
        background-size: contain;
        background-repeat: no-repeat;
        position: fixed;
        bottom: 0;
    }
}
</style>